import { Spine } from 'pixi-spine';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import { Container, Sprite } from 'pixi.js';
import Sound from '../../gamma-engine/core/sound/Sound';
import SoundManager from '../../gamma-engine/core/sound/SoundManager';
import SoundListExtended from '../sound/SoundListExtended';
import IAdjustableLayout from '../../gamma-engine/core/view/IAdjustableLayout';
import { UpdateLayoutDescription } from '../../gamma-engine/core/view/UpdateLayoutDescription';
import SoundList from '../../gamma-engine/common/sound/SoundList';
import { ScreenOrientation } from '../../gamma-engine/core/view/ScreenOrientation';

import { Tweener } from '../libs/engineTween';
import NoSleep from 'nosleep.js';
import { getFromLocalStorage } from '../model/LocalStorageUtils';

export default class MainScreenBackground extends Container implements IAdjustableLayout {
    private static DEFAULT_BACKGROUND_CHANNEL: string = 'ambient';

    private _theme: BackgroundType;
    private backgroundMusic: Sound;
    public nosleep: NoSleep;
    private currentAnimation: Spine;
    private readonly MUSIC_DELAY_SECONDS: number = 1;
    private readonly VISIBILITY_DELAY_SECONDS: number = 0.1;
    // VISUALS
    private mainAnimation: Spine;
    // private mainAnimationMobile: Spine;
  
    // private freegameAnimation: Spine;
    private staticBackground: Sprite;
    constructor() {
        super();
        //
        this.mainAnimation = new Spine(AssetsManager.spine.get(BackgroundType.NORMAL));
        // this.mainAnimationMobile = new Spine(AssetsManager.spine.get(BackgroundType.NORMAL_MOBILE));
        var self = this
        this.nosleep = new NoSleep()
      if (getFromLocalStorage('settings')?.introScreen) {
            this.nosleep.enable();
            this.scheduleBackgroundMusicUpdate(this.MUSIC_DELAY_SECONDS);
        }

        document.body.addEventListener('pointerdown', () => {
            this.nosleep.enable();
            this.scheduleBackgroundMusicUpdate(this.MUSIC_DELAY_SECONDS);
        }, { once: true });

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== "hidden") {
                this.scheduleBackgroundMusicUpdate(this.VISIBILITY_DELAY_SECONDS);
            }
        });

        document.addEventListener('focus', () => {
            this.scheduleBackgroundMusicUpdate(this.VISIBILITY_DELAY_SECONDS);
        });

        this.theme = BackgroundType.NORMAL;
        this.scheduleBackgroundMusicUpdate(this.MUSIC_DELAY_SECONDS);
    }

    public set theme(type: BackgroundType) {
        if (this._theme === type)
            return;

        this._theme = type;
        switch (this._theme) {
            case BackgroundType.NORMAL:
                this.swap(this.mainAnimation, 'animation',true);
                break;
            case BackgroundType.FREEGAME:
                this.swap(this.mainAnimation, 'animation',true);
                break;
        }
    }
    private scheduleBackgroundMusicUpdate(delaySeconds: number): void {
        Tweener.addCaller(this, {
            count: 1,
            time: delaySeconds,
            onComplete: () => this.updateBackgroundMusic()
        });
    }
    private swap(animation: Spine, id: string,loop:boolean): void {
        if (!this.currentAnimation) {
            this.currentAnimation = animation;
            this.addChild(this.currentAnimation);
        } else {
            const prevAnimation: Spine = this.currentAnimation;
            this.currentAnimation = animation
            if (this.backgroundMusic) {
                Tweener.addTween(this.backgroundMusic,
                    {
                        time: 0.45,
                        transition: 'linear',
                        onComplete: () => {
                            this.updateBackgroundMusic();
                        }
                    });
            }
        }
        this.currentAnimation.state.setAnimation(0, id, loop);
    }

    private updateBackgroundMusic(): void {
        if (this.backgroundMusic) {
            this.backgroundMusic.stop();
        }

        this.backgroundMusic = SoundManager.loop({
            id: this._theme === BackgroundType.NORMAL ? SoundListExtended.BASEGAME_BACKGROUND : SoundListExtended.FREEGAME_BACKGROUND,
            channel: MainScreenBackground.DEFAULT_BACKGROUND_CHANNEL
        });
    }

    public updateLayout(desc: UpdateLayoutDescription) {
        switch (desc.orientation) {
            case ScreenOrientation.HORIZONTAL:
                const xScale: number = desc.currentWidth / desc.baseWidth;
                const yScale: number = desc.currentHeight / desc.baseHeight;
                

                this.scale.set(xScale > yScale ? xScale : yScale);
                break;
            case ScreenOrientation.VERTICAL:
                // const offsetX = (desc.currentWidth - desc.baseWidth) / 2
                // const backgroundWidth = 1920
                this.scale.set((desc.currentHeight / desc.baseHeight) * 2);
                // this.pivot.x = -(backgroundWidth / 2)
                // this.x = 0 - offsetX
                break;
        }
    }
}

export enum BackgroundType {
    NORMAL = 'main-screen-background',
    FREEGAME = 'freegame-screen-background',
    WINNING = 'winning'
}
